import Axios from "axios";
import { format, subMonths } from "date-fns";
import React from "react";
import CreateTimesheet from "../CreateTimesheet/CreateTimesheet";
import OldTimesheet from "../CreateTimesheet/OldTimesheet/OldTimesheet";
import ThankYouForSubmitting from "../CreateTimesheet/ThankYouForSubmitting/ThankYouForSubmitting";
import TeacherPortalCalendar from "../TeacherPortalCalendar/TeacherPortalCalendar";
import { baseUrl } from "../assets/Animations";
import { useSafeArea } from "../capacitor";
import { disconnectSocket, socket } from "../service/socket";
import AvailabilityByDayPopup from "./AvailabilityByDayPopup/AvailabilityByDayPopup";
import CalendarGeneratedTimesheetFlow from "./CalendarGeneratedTimesheetFlow/CalendarGeneratedTimesheetFlow";
import NotesPopupTeacherPortal from "./NotesPopupTeacherPortal/NotesPopupTeacherPortal";
import TeacherPortalBottomMenu from "./TeacherPortalBottomMenu/TeacherPortalBottomMenu";
import AvailabilityScreenTeacherPortal from "./TeacherPortalScreens/AvailabilityScreenTeacherPortal";
import NeedsToBeResetTeacherPortalScreen from "./TeacherPortalScreens/NeedsToBeResetTeacherPortalScreen";
import ProfileScreenTeacherPortal from "./TeacherPortalScreens/ProfileScreenTeacherPortal";
import TimesheetScreenTeacherPortal from "./TeacherPortalScreens/TimesheetScreenTeacherPortal";
import "./teacher-portal-2021.css";

let typingTimer;

const TeacherPortal2021 = (props) => {
  const [view, setView] = React.useState("");
  const [oldTimesheets, setOldTimesheets] = React.useState([]);
  const [firstPass, setFirstPass] = React.useState("");
  const [secondPass, setSecondPass] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [needsToReset, setNeedsToReset] = React.useState(Boolean);
  const [passWarning, setPassWarning] = React.useState(false);
  const [availabilityByDay, setAvailabilityByDay] = React.useState("");
  const [teacherAvail, setTeacherAvail] = React.useState({});
  const [teacherNotes, setTeacherNotes] = React.useState("");
  const [month, setMonth] = React.useState("");
  const [year, setYear] = React.useState("");
  const [schoolAbb, setSchoolAbb] = React.useState("");
  const [schoolName, setSchoolName] = React.useState("");
  const [openUpTheTimesheet, setOpenUpTheTimesheet] = React.useState(false);
  const [thankYouForSubmitting, setThankYouForSubmitting] =
    React.useState(false);
  const [oldTimesheet, setOldTimesheet] = React.useState(false);
  const [phone, setPhone] = React.useState("");
  const [address, setAddress] = React.useState({});
  const [loadingId, setLoadingId] = React.useState("");
  const [wantsMoreStudents, setWantsMoreStudents] = React.useState(true);
  const [tryingToSubmitTimesheet, setTryingToSubmitTimesheet] =
    React.useState(false);
  const [logo, setLogo] = React.useState("");
  const [bottomMenuView, setBottomMenuView] = React.useState("timesheets");
  const [notesPopup, setNotesPopup] = React.useState(false);

  const initialRender1 = React.useRef(true);
  const initialRender2 = React.useRef(true);
  const initialRender3 = React.useRef(true);

  const myToken = localStorage.getItem("token");
  const myHeader = { headers: { Authorization: `Bearer ${myToken}` } };

  React.useEffect(() => {
    createDateSettings();

    const handleSocketConnection = () => {
      if (document.visibilityState === "visible") {
        if (socket.connected === false) {
          socket.connect();
        }
      } else {
        disconnectSocket();
      }
    };
    window.addEventListener("visibilitychange", handleSocketConnection);
    return () => {
      window.removeEventListener("visibilitychange", handleSocketConnection);
    };
  }, []);

  React.useEffect(() => {
    setView(bottomMenuView);
  }, [bottomMenuView]);

  //INITIALIZING STATE BASED ON USERDATA ONCE WE GET IT
  React.useEffect(() => {
    if (JSON.stringify(props.userData) !== JSON.stringify({})) {
      setPhone(props.userData.PhoneNumber);
      setAddress({
        StreetAddress: props.userData.Address.StreetAddress,
        City: props.userData.Address.City,
        State: props.userData.Address.State,
        Zip: props.userData.Address.Zip,
      });
      setWantsMoreStudents(props.userData.WantsMoreStudents);
      setTeacherAvail(props.userData.AvailabilityDetails);
      setTeacherNotes(props.userData.Notes);
      setNeedsToReset(props.userData.NeedsToReset);
      setEmail(props.userData.Email);
      setTheSchool();
      if (props.userData.School === "mma") {
        setLogo("mmalogo.png");
      } else if (props.userData.School === "lsma") {
        setLogo("lakesidelogo.png");
      } else if (props.userData.School === "tma") {
        setLogo("treesidelogo.png");
      } else if (props.userData.School === "mor") {
        setLogo("morningsidelogo.png");
      } else if (props.userData.School === "psma") {
        setLogo("parksidelogo.png");
      } else if (props.userData.School === "tem") {
        setLogo("https://www.atharomusic.com/tempe-logo__dark.png");
      } else if (props.userData.School === "den") {
        setLogo("https://www.atharomusic.com/denton-logo__dark.png");
      } else if (props.userData.School === "tul") {
        setLogo("https://www.atharomusic.com/tulsa-logo__dark.png");
      }
      initialRender1.current = true;
      initialRender2.current = true;
      initialRender3.current = true;
    }
  }, [props.userData]);

  React.useEffect(() => {
    view === "timesheets" && getOldTimesheets();
    view !== "timesheets" && setOpenUpTheTimesheet(false);
  }, [view]);

  React.useEffect(() => {
    if (
      initialRender1.current &&
      JSON.stringify(address) === JSON.stringify({})
    ) {
      return;
    } else if (initialRender1.current) {
      initialRender1.current = false;
    } else {
      typingTimer = setTimeout(() => sendTheUpdate(loadingId), 500);
    }
  }, [address]);

  React.useEffect(() => {
    if (initialRender2.current && phone === "") {
      return;
    } else if (initialRender2.current) {
      initialRender2.current = false;
    } else {
      typingTimer = setTimeout(() => sendTheUpdate(loadingId), 500);
    }
  }, [phone]);

  // React.useEffect(() => {
  //     if(initialRender3.current && teacherNotes === '') {
  //         return
  //     } else if (initialRender3.current) {
  //         initialRender3.current = false
  //     } else {
  //         typingTimer = setTimeout(() => sendTheNotes(loadingId), 200)
  //     }
  // }, [teacherNotes])

  const setTheSchool = () => {
    let url = window.location.href;
    let trimmed = url.substring(8);
    let name = trimmed.split(".")[0];
    if (
      name === "mountainside" ||
      name === "ocalhost:3000/teacherportal" ||
      name === "ocalhost:8080/teacherportal/"
    ) {
      setSchoolAbb("MMA");
      setSchoolName("Mountainside Music Academy");
    } else if (name === "lakeside") {
      setSchoolAbb("LSMA");
      setSchoolName("Lakeside Music Academy");
    } else if (name === "treeside") {
      setSchoolAbb("TMA");
      setSchoolName("Treeside Music Academy");
    } else if (name === "morningside") {
      setSchoolAbb("MOR");
      setSchoolName("Morningside Music Academy");
    } else if (name === "parkside") {
      setSchoolAbb("PSMA");
      setSchoolName("Parkside Music Academy");
    } else if (name === "tempe") {
      setSchoolAbb("TEM");
      setSchoolName("Tempe Music Academy");
    } else if (name === 'denton') {
      setSchoolAbb("DEN");
      setSchoolName("Denton Music Academy");
    } else if (name === "tulsa") {
      setSchoolAbb("TUL");
      setSchoolName("Tulsa Music Academy");
    }
  };

  const createDateSettings = () => {
    if (format(new Date(), "d") < 15) {
      setMonth(format(subMonths(new Date(), 1), "MMMM"));
      setYear(format(subMonths(new Date(), 1), "yyyy"));
    } else {
      setMonth(format(new Date(), "MMMM"));
      setYear(format(new Date(), "yyyy"));
    }
  };

  const getOldTimesheets = async () => {
    let res = await Axios.get(
      `${baseUrl}/oldtimesheets/${props.userData.TeacherID}`,
      myHeader
    );
    setOldTimesheets(res.data);
  };
  const viewOldTimesheet = async (oldTimesheetId) => {
    let res = await Axios.get(
      `${baseUrl}/oldtimesheet/${oldTimesheetId}`,
      myHeader
    );
    setOldTimesheet(res.data);
  };

  const updateAndCloseAvailabilityModal = (wholeAvail) => {
    Axios.put(
      `${baseUrl}/teacherschedule`,
      {
        Email: props.userData.Email,
        AvailabilityDetails: wholeAvail,
      },
      myHeader
    )
      .then((res) => {
        setTeacherAvail(res.data.AvailabilityDetails);
        setAvailabilityByDay("");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateProfile = (value, hookFunction, id, key) => {
    setLoadingId(id);
    clearTimeout(typingTimer);
    if (key) {
      hookFunction((oldAddress) => ({ ...oldAddress, [key]: value }));
    } else {
      hookFunction(value);
    }
  };

  const sendWantsMoreStudentsSwitch = (bool) => {
    document.body.style.cursor = "wait";
    Axios.put(
      `${baseUrl}/teacherwantsmorestudents/${props.userData.TeacherID}`,
      {
        Name: props.userData.Name,
        School: props.userData.School,
        WantsMoreStudents: bool,
      },
      myHeader
    )
      .then((res) => {
        document.body.style.cursor = "default";
        setWantsMoreStudents(bool);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const sendTheNotes = (id) => {
    document.body.style.cursor = "wait";
    Axios.put(
      `${baseUrl}/teachernotesupdate`,
      {
        Email: props.userData.Email,
        Name: props.userData.Name,
        School: props.userData.School,
        Notes: teacherNotes,
      },
      myHeader
    )
      .then((res) => {
        setNotesPopup(false);
        document.body.style.cursor = "pointer";
        if (document.getElementById(id))
          document.getElementById(id).style.outline = "2px solid green";
        if (document.getElementById(id))
          document.getElementById(id).style.animation = "none";
      })
      .catch((err) => {
        document.body.style.cursor = "pointer";
        console.log(err);
      });
  };

  const sendTheUpdate = (id) => {
    Axios.put(
      `${baseUrl}/teachercontact`,
      {
        Email: props.userData.Email,
        PhoneNumber: phone,
        Address: address,
      },
      myHeader
    )
      .then((res) => {
        if (document.getElementById(id))
          document.getElementById(id).style.outline = "2px solid green";
        if (document.getElementById(id))
          document.getElementById(id).style.animation = "none";
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const startTimesheetProcess = () => {
    setTryingToSubmitTimesheet(true);
    //setWantsMoreStudentsPopup(true)
    setOpenUpTheTimesheet(true);
  };
  const openUpAvailPopup = (theDay) => {
    if (wantsMoreStudents) {
      setAvailabilityByDay(theDay);
    }
  };
  const pushNewTimesheetToTimesheets = (newSheet) => {
    setOldTimesheets((arr) => [...arr, newSheet]);
  };

  const passwordSubmit = () => {
    if (firstPass === secondPass) {
      Axios.put("https://app.atharo.app/passreset", {
        Email: email,
        Password: firstPass,
      })
        .then((response) => {
          setNeedsToReset(false);
        })
        .catch((e) => {
          console.log("Error Password Update did not work: " + e);
        });
    }
  };
  const resetPass2 = (e) => {
    setSecondPass(e);
    if (firstPass !== e) {
      setPassWarning(true);
    } else {
      setPassWarning(false);
    }
  };

  const insets = useSafeArea();

  if (needsToReset) {
    return (
      <NeedsToBeResetTeacherPortalScreen
        schoolName={schoolName}
        schoolAbb={schoolAbb}
        setFirstPass={setFirstPass}
        resetPass2={resetPass2}
        passwordSubmit={passwordSubmit}
        passWarning={passWarning}
      />
    );
  } else {
    return (
      <div
        className="new-teacher-portal"
        style={{ paddingTop: 10 + insets?.top }}
      >
        {availabilityByDay && (
          <AvailabilityByDayPopup
            setAvailabilityByDay={setAvailabilityByDay}
            dayToEdit={availabilityByDay}
            availability={teacherAvail}
            updateAndCloseAvailabilityModal={updateAndCloseAvailabilityModal}
          />
        )}
        {thankYouForSubmitting && (
          <ThankYouForSubmitting
            setThankYouForSubmitting={setThankYouForSubmitting}
          />
        )}
        {oldTimesheet && (
          <OldTimesheet
            oldTimesheet={oldTimesheet}
            teacher={props.userData}
            setOldTimesheet={setOldTimesheet}
          />
        )}
        {openUpTheTimesheet &&
          props.userData.School !== "psma" &&
          props.userData.School !== "mor" &&
          props.userData.School !== "tma" &&
          props.userData.School !== "mma" &&
          props.userData.School !== "tem" &&
          props.userData.School !== "den" &&
          props.userData.School !== "tul" &&
          props.userData.School !== "lsma" && (
            <CreateTimesheet
              month={month}
              myYear={year}
              reviewing={false}
              rate={props.userData.Rate}
              userData={props.userData}
              setOpenUpTheTimesheet={setOpenUpTheTimesheet}
              setThankYouForSubmitting={setThankYouForSubmitting}
              setTryingToSubmitTimesheet={setTryingToSubmitTimesheet}
              pushNewTimesheetToTimesheets={pushNewTimesheetToTimesheets}
            />
          )}
        {openUpTheTimesheet &&
          bottomMenuView === "timesheets" && (
            <CalendarGeneratedTimesheetFlow
              month={month}
              myYear={year}
              reviewing={false}
              rate={props.userData.Rate}
              userData={props.userData}
              setOpenUpTheTimesheet={setOpenUpTheTimesheet}
              setThankYouForSubmitting={setThankYouForSubmitting}
              setTryingToSubmitTimesheet={setTryingToSubmitTimesheet}
              pushNewTimesheetToTimesheets={pushNewTimesheetToTimesheets}
              setBottomMenuView={setBottomMenuView}
            />
          )}
        {notesPopup && (
          <NotesPopupTeacherPortal
            setNotesPopup={setNotesPopup}
            teacherNotes={teacherNotes}
            setTeacherNotes={setTeacherNotes}
            sendTheNotes={sendTheNotes}
          />
        )}
        {view === "timesheets" && (
          <TimesheetScreenTeacherPortal
            oldTimesheets={oldTimesheets}
            month={month}
            viewOldTimesheet={viewOldTimesheet}
            startTimesheetProcess={startTimesheetProcess}
          />
        )}
        {view === "availability" && (
          <AvailabilityScreenTeacherPortal
            tryingToSubmitTimesheet={tryingToSubmitTimesheet}
            wantsMoreStudents={wantsMoreStudents}
            sendWantsMoreStudentsSwitch={sendWantsMoreStudentsSwitch}
            teacherNotes={teacherNotes}
            openUpAvailPopup={openUpAvailPopup}
            teacherAvail={teacherAvail}
            setNotesPopup={setNotesPopup}
          />
        )}
        {view === "profile" && (
          <ProfileScreenTeacherPortal
            userData={props.userData}
            address={address}
            phone={phone}
            updateProfile={updateProfile}
            setPhone={setPhone}
            setAddress={setAddress}
          />
        )}
        {view === "calendar" && (
          <TeacherPortalCalendar
            setView={setView}
            userData={props.userData}
            socket={socket}
          />
        )}
        <TeacherPortalBottomMenu
          bottomMenuView={bottomMenuView}
          setBottomMenuView={setBottomMenuView}
          userData={props.userData}
        />
      </div>
    );
  }
};
export default TeacherPortal2021;
